import { useCallback, useEffect, useState } from "react";
import Areas from "./Areas";
import Treatments from "./Treatments";
import areaData from "./area_data";
import treatmentData from "./online_treatment_data.json";
import Loader from "./Loader";
import ErrorMessage from "./ErrorMessage";

export default function Services() {
  const [host, setHost] = useState(window.location.host);
  const [initializing, setInitializing] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [areas, setAreas] = useState(areaData);
  // eslint-disable-next-line no-unused-vars
  const [treatments, setTreatments] = useState(treatmentData);
  const [availableTreatments, setAvailableTreatments] = useState(treatmentData);
  // const selectedArea = useSelector((state) => state.servicesList.selectedArea);
  const [selectedArea, setSelectedArea] = useState(null);
  const [showAllTreatments, setShowAllTreatments] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [showError, setShowError] = useState(false);

  // TODO: this allow the dev team to run the `npm start` command until the application is refactored.
  const isDevelopment = process.env.NODE_ENV === 'development';
  const wpAppPort = 6001;
  const wpAppHost = 'localhost';
  const wpAppDomain = isDevelopment ? `http://${wpAppHost}:${wpAppPort}` : window.location.origin;

  function smoothScroll(target) {
    const targetElement = document.querySelector(target);

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  }

  const getTreatments = useCallback((area, remove) => {
    if (!area) {
      setAvailableTreatments(treatmentData);
      return;
    }

    let filteredTreatments;
    if (remove) {
      filteredTreatments = treatmentData.filter((treatment) => treatment.areas.indexOf(area) === -1);
    } else {
      filteredTreatments = treatmentData.filter((treatment) => treatment.areas.indexOf(area) > -1);
    }
    setAvailableTreatments(filteredTreatments);
  }, []);

  const setSelectArea = useCallback(
    (area) => {
      console.log("setSelectArea", area);
      setShowAllTreatments(false)
      setSelectedArea(area.slug)
      getTreatments(area.slug);
    },
    [getTreatments]
  );

  useEffect(() => {
    if (initializing) {
      let searchParams = new URLSearchParams(document.location.search), areaToSelect = null;
      if (searchParams.get("area") || searchParams.get("_areas")) {
        let searchArea = searchParams.get("area") || searchParams.get("_areas");
        areaToSelect = areas.filter((item, index) => {
          return item.slug === searchArea;
        });
        setSelectArea(areaToSelect[0]);
      }
      if (window.location.hostname !== "localhost") {
        setHost(window.location.host);
      }

      setInitializing(false);
    }
  }, [host, initializing, areas, selectedArea, getTreatments, setSelectArea]);

  const handleBookNow = (treatment) => {
    window.location.href = wpAppDomain + "/book-now?serviceId=" + treatment.serviceId;
  };

  const goToAllTreatments = () => {
    setSelectedArea(null);
    setShowAllTreatments(true);

    getTreatments();
    smoothScroll("#areas");
  };

  return (
    <>
      <div className="">
        <div className="services-wrapper" id="servicesList">
          <div className="flex flex-col items-center py-10">
            <div id="areas" data-title="Services" className="w-full">
              {areas && <Areas areas={areas} selectArea={setSelectArea} selectedArea={selectedArea} host={wpAppDomain} />}
            </div>
            <div className="">
              <div className="text-center">
                {!showAllTreatments && (
                  <button type="button" className="button--ghost-small" onClick={() => goToAllTreatments()}>
                    See All Treatments
                  </button>
                )}
              </div>
            </div>
            <div className="services-section" id="treatments" data-title="Treatments">
              {treatments && (
                <Treatments treatments={availableTreatments} showTreatments={availableTreatments} handleBookNow={handleBookNow} host={wpAppDomain} />
              )}
            </div>
            <div className="text-teal-900 font-capito text-lg">
              Still not sure?{' '}
              <a href="/services/#attune-services" className="font-bold underline">Use our Treatment Finder</a>
            </div>
          </div>
        </div>
        {loading && <Loader />}
        {showError && <ErrorMessage />}
      </div>
    </>
  );
}
